import React from "react";

const Section10 = () => {
  return (
    <section className="container-1280 my-[-10px] md:my-[-100px] xl:min-w-[70%] lg:min-w-[90%] w-[95%] md:pt-10 m-auto">
      <div className="flex flex-col items-center gap-12 md:flex-row md:justify-start justify-evenly md:gap-24">
        <div>
          <h2 className="text-[26px] md:text-[30px] text-[#ea2339] font-bold mt-[-50px] md:mt-[0]">Our Partners</h2>
        </div>
        <div className="flex items-center gap-8 md:gap-16">
          <img
            src="../../../assets/shopify-logo-colored.png"
            alt=""
            className="h-auto w-28 md:w-52 md:h-auto"
          />
          <img
            src="../../../../assets/automattic-logo.png"
            alt=""
            className="h-auto w-28 lg:w-52 lg:h-auto"
          />
          <img
            src="../../../../assets/amazonpay-logo.png"
            alt=""
            className="h-auto w-28 lg:w-52 lg:h-auto"
          />
        </div>
      </div>
      <div className="w-full h-px mt-10 bg-gray-800"></div>
    </section>
  );
};

export default Section10;
